var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlutonicLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 56,
    viewBox: "0 0 96 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.9776 38.8453L95.9194 27.8382L47.9888 0L0 27.7217L28.7117 44.4944L28.8282 55.5598L47.9306 44.378V33.4291L67.1494 44.4944V55.5598L95.9776 38.8453ZM67.2076 22.2472L76.817 27.7799L67.2076 33.3126V22.2472Z",
    fill: "#22AAEE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlutonicLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plutonicLogo.60bcdd2a6994bff860da5a71a315e602.svg";